"use client";

import React, { createContext, useContext, type ReactNode } from "react";
import {
  useOtrosProyectosData,
  type OtrosProyectosData,
} from "@/hooks/useOtrosProyectosData";

const OtrosProyectosContext = createContext<OtrosProyectosData | undefined>(undefined);

export const useOtrosProyectos = () => {
  const ctx = useContext(OtrosProyectosContext);
  if (!ctx) {
    throw new Error("useOtrosProyectos must be used within an OtrosProyectosProvider");
  }
  return ctx;
};

export function OtrosProyectosProvider({ children }: { children: ReactNode }) {
  const value = useOtrosProyectosData();
  return (
    <OtrosProyectosContext.Provider value={value}>
      {children}
    </OtrosProyectosContext.Provider>
  );
}